import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useTenant } from '../context/TenantContext';
import { FEATURE_NAMES } from '../lib/features';
import './FeatureGate.css';

/** Shows `children` if the company's plan includes `feature`; otherwise says it isn't included, with a way to upgrade. */
export default function FeatureGate({ feature, children }) {
  const { hasFeature, can } = useTenant();
  if (hasFeature(feature)) return children;
  return (
    <section className="feature-gate" role="status">
      <span className="feature-gate-icon"><Lock size={22} /></span>
      <h2>{FEATURE_NAMES[feature] || 'This feature'} isn't included in your plan</h2>
      <p>{can('billing.manage') ? 'Choose a plan that includes it to start using it.' : 'Ask your company owner about a plan that includes it.'}</p>
      {can('billing.manage') && <Link className="feature-gate-btn" to="/billing">See plans</Link>}
    </section>
  );
}
